import { Component, OnInit, OnDestroy } from '@angular/core'
import { Router } from '@angular/router'
import { AuthService } from '../../auth.service'
import { switchMap, takeUntil, tap } from 'rxjs/operators'
import { from, Subject } from 'rxjs'
import { User } from 'oidc-client-ts'

@Component({
  selector: 'lib-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss'],
  standalone: false
})
export class LoginComponent implements OnInit, OnDestroy {
  private destroyed$: Subject<void>

  ngOnInit(): void {
    this.authService
      .completeAuthentication()
      .pipe(
        takeUntil(this.destroyed$),
        tap(u => {
          sessionStorage.setItem('access_token', u && u.access_token)
        }),
        switchMap((u: User) => {
          return from(this.router.navigateByUrl((u.state as string) || '/'))
        })
      )
      .subscribe()
  }

  ngOnDestroy(): void {
    this.destroyed$.next()
    this.destroyed$.complete()
  }

  constructor(private router: Router, private authService: AuthService) {
    this.destroyed$ = new Subject<void>()
  }
}
